import React from "react";
import styled from "styled-components";

const TimelineDetail = styled.div`
    display: grid;
    grid-template-columns: minmax(8rem, 12rem) minmax(0, 1fr);
    gap: 1rem;
    align-items: start;

    h6 {
        color: ${p => p.theme.color};
    }

    p {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

// Displays one non-empty event detail row.
const Timeline_Detail_Value = (props) => {
    return (
        <TimelineDetail>
            <h6>{props.label}</h6>
            <p>{props.value}</p>
        </TimelineDetail>
    );
};

// Removes an empty detail row from compact event output.
const Timeline_Detail_Empty = () => {
    return null;
};

const timelineDetailLookup = {
    true: Timeline_Detail_Value,
    false: Timeline_Detail_Empty
};

// Displays one compact label and value pair inside an event renderer.
export const Timeline_Detail = (props) => {
    const TimelineDetailState = timelineDetailLookup[Boolean(`${props.value || ""}`.trim())];

    return (
        <TimelineDetailState label={props.label} value={props.value} />
    );
};
